import FilterParamsUtil from "../sections/collection-grid/filter-params-util";

const CollectionGridLoadMore = (el, sectionParams, onChangeFilterParams) => {
  let filterParams = [];
  let result = null;

  const initialize = () => {
    const button = el.querySelector(".fs-load-more-button");
    button.addEventListener("click", () => {
      const newFilterParams = [
        ...filterParams.filter((fp) => fp.key != "page"),
        { key: "page", value: result.page + 1 },
      ];
      onChangeFilterParams(newFilterParams);
    });
  };

  const setFilterParams = (newFilterParams) => {
    filterParams = newFilterParams;
  };

  const setResult = (newResult) => {
    if (sectionParams.collection.handle != "all") {
      el.classList.remove("show");
      return;
    }
    result = newResult;
    if (!result || result.nbPages <= 0 || result.nbPages <= result.page) {
      el.classList.remove("show");
    } else {
      el.classList.add("show");
    }
  };

  initialize();

  return {
    setFilterParams: setFilterParams,
    setResult: setResult,
  };
};

export default CollectionGridLoadMore;
